// extracted by mini-css-extract-plugin
export var errorIcon = "_n3-1";
export var nameLogo = "_n3-0";